export default function addClickHandler(element, callback) {
  element.addEventListener('click', callback, false);
}
